var _rect, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 50 337 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 232.948,
    height: 146.49,
    rx: 25.8056,
    transform: "matrix(-1 0 0 1 286.499 113.05)",
    fill: "#FFCE8C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_316_3403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.193 178.22L153.262 175.375C153.554 165.613 154.607 157.85 156.421 152.089C158.291 146.328 160.916 141.702 164.294 138.211C167.672 134.72 171.712 131.58 176.413 128.791C179.926 126.643 183.078 124.402 185.87 122.07C188.662 119.737 190.902 117.139 192.591 114.277C194.28 111.359 195.169 108.087 195.257 104.461C195.35 100.611 194.511 97.2132 192.74 94.2674C190.969 91.3216 188.54 89.0297 185.454 87.3919C182.423 85.7554 179.039 84.8919 175.301 84.8014C171.674 84.7136 168.223 85.4395 164.948 86.9792C161.674 88.463 158.967 90.7422 156.827 93.8166C154.689 96.8352 153.48 100.63 153.202 105.201L119.057 104.374C119.606 93.2225 122.507 84.0815 127.76 76.9514C133.014 69.7654 139.869 64.4884 148.324 61.1203C156.781 57.6964 166.058 56.1067 176.157 56.3512C187.26 56.62 197.035 58.6989 205.482 62.5879C213.93 66.421 220.498 71.8556 225.184 78.8914C229.871 85.9272 232.096 94.327 231.859 104.091C231.701 110.618 230.473 116.395 228.174 121.419C225.932 126.389 222.839 130.78 218.895 134.592C214.952 138.349 210.321 141.726 205 144.723C200.529 147.239 196.837 149.885 193.922 152.661C191.064 155.439 188.892 158.68 187.406 162.385C185.977 166.091 185.168 170.677 184.98 176.143L184.911 178.988L153.193 178.22ZM168.467 232.183C162.887 232.048 158.164 229.979 154.298 225.978C150.488 221.922 148.678 217.133 148.867 211.611C148.944 206.142 150.982 201.502 154.982 197.691C159.038 193.881 163.856 192.044 169.435 192.179C174.735 192.308 179.347 194.373 183.269 198.376C187.192 202.379 189.115 207.114 189.038 212.583C188.893 216.264 187.835 219.616 185.864 222.639C183.95 225.607 181.464 227.975 178.407 229.744C175.351 231.456 172.037 232.269 168.467 232.183Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_316_3403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.13 248.688C320.833 248.688 327.079 254.933 327.079 262.637V336.566C327.079 344.27 320.833 350.515 313.13 350.515H305.478L286.975 381.552L269.07 350.515H207.117C199.414 350.515 193.168 344.27 193.168 336.566V262.637C193.168 254.933 199.414 248.688 207.117 248.688H313.13Z",
    fill: "url(#paint0_linear_316_3403)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.41555,
    cy: 9.41555,
    r: 9.41555,
    transform: "matrix(-1 0 0 1 302.668 293.325)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.41555,
    cy: 9.41555,
    r: 9.41555,
    transform: "matrix(-1 0 0 1 271.283 293.325)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.41555,
    cy: 9.41555,
    r: 9.41555,
    transform: "matrix(-1 0 0 1 239.897 293.325)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_316_3403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.949 249.019C16.2452 249.019 10 255.264 10 262.968L10 336.898C10 344.601 16.2452 350.847 23.949 350.847H31.6001L50.1027 381.883L68.0085 350.847L129.961 350.847C137.665 350.847 143.91 344.601 143.91 336.898L143.91 262.968C143.91 255.264 137.665 249.019 129.961 249.019L23.949 249.019Z",
    fill: "url(#paint1_linear_316_3403)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.8261,
    cy: 303.071,
    r: 9.41555,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.2113,
    cy: 303.071,
    r: 9.41555,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.596,
    cy: 303.072,
    r: 9.41555,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_316_3403",
    x: 109.159,
    y: 50.9524,
    width: 130.658,
    height: 192.314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.78979
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.695 0 0 0 0 0.479893 0 0 0 0 0.189967 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_3403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_3403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_316_3403",
    x: 183.469,
    y: 234.808,
    width: 153.308,
    height: 152.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.18061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.84951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_3403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_3403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_316_3403",
    x: 0.300974,
    y: 235.139,
    width: 153.308,
    height: 152.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.18061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.84951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_3403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_3403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_3403",
    x1: 193.168,
    y1: 305.181,
    x2: 323.243,
    y2: 302.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_3403",
    x1: 10,
    y1: 284.589,
    x2: 140.423,
    y2: 283.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F79BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ABDC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.49cab2533a45e7ead6bc4630325421b8.svg";
export { ForwardRef as ReactComponent };